export class Credencial {
    login : string;
    senha : string;
    username : string;
    token : string;
} 